import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const QuickActionCard = ({ action }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(action?.path);
  };

  const colorClasses = {
    blue: 'bg-blue-50 text-blue-600 dark:bg-blue-900/20 dark:text-blue-400',
    green: 'bg-green-50 text-green-600 dark:bg-green-900/20 dark:text-green-400',
    amber: 'bg-amber-50 text-amber-600 dark:bg-amber-900/20 dark:text-amber-400',
    purple: 'bg-purple-50 text-purple-600 dark:bg-purple-900/20 dark:text-purple-400'
  };

  return (
    <button
      onClick={handleClick}
      className="bg-card rounded-xl p-4 md:p-5 lg:p-6 border border-border hover:border-primary hover:shadow-lg transition-all duration-250 text-left w-full group"
    >
      <div className={`w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-lg ${colorClasses?.[action?.color]} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-250`}>
        <Icon name={action?.icon} size={24} className="md:w-7 md:h-7 lg:w-8 lg:h-8" />
      </div>
      <h3 className="text-base md:text-lg lg:text-xl font-semibold text-foreground mb-2">
        {action?.title}
      </h3>
      <p className="text-sm md:text-base text-muted-foreground line-clamp-2">
        {action?.description}
      </p>
      <div className="flex items-center gap-2 mt-4 text-primary text-sm md:text-base font-medium">
        <span>Commencer</span>
        <Icon name="ArrowRight" size={16} className="group-hover:translate-x-1 transition-transform duration-250" />
      </div>
    </button>
  );
};

export default QuickActionCard;